import loadable from "@loadable/component";
import { inject, observer } from "mobx-react";
import { useParams } from "react-router";
import type { Store } from "@inferno/renderer-shared-core";
import type { BlockFragment } from "@ihr-radioedit/inferno-webapi";
import { ILog } from "@ihr-radioedit/inferno-core";
import type { PageBlockInterface } from "../Block.component";

const Search = loadable(() => import("./Search.component"));

const log = ILog.logger("Search Loader");

interface SearchProps extends PageBlockInterface {
  block: BlockFragment;
  store?: Store;
  params?: ReturnType<typeof useParams>;
}

export const SearchLoader = inject("store")(
  observer(({ store, params, block }: SearchProps) => {
    if (!store || !params || !params.keyword) {
      log.error("Search Page is unavailable.");
      return null;
    }

    const engineId = store.env.GOOGLE_CSE_ACCOUNT_ID || "";
    const max = store.env.GOOGLE_CSE_MAX_RESULTS || "";
    const adId = store.env.GOOGLE_CSE_AD_ID || "";

    return <Search engineId={engineId} keyword={params.keyword} max={max} adId={adId} block={block} />;
  }),
);

export default SearchLoader;
